import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("shumway_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const setAuth = (token, user) => {
  localStorage.setItem("shumway_token", token);
  localStorage.setItem("shumway_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("shumway_token");
  localStorage.removeItem("shumway_user");
};
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("shumway_user")); } catch { return null; }
};
